// extracted by mini-css-extract-plugin
export default {"themeColour1":"#00ff9f","themeColour2":"#00b8ff","themeColour3":"#001eff","themeColour4":"#bd00ff","themeColour5":"#d600ff"};